import React from "react";

import Layout from "../containers/layout";
import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import PageContainer from "../components/pageContainer";
import DiaMain from "../components/diaMain";

const Diagnostika = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const magazinPreview = data && data?.magazinPreview?.nodes;
  const allServices = data && data?.allServices?.nodes;
  const tags = data && data?.tags?.nodes;

  return (
    <Layout services={allServices} tags={tags} magazin={magazinPreview}>
      <SEO
        title={"TCM Diagnostika"}
        description={"Diagnostika podle TCM"}
        keywords={["TCM", "Tradiční čínská medicína", "Diagnostika", "Ekzém"]}
      />
      <PageContainer>
        <DiaMain />
      </PageContainer>
    </Layout>
  );
};

export default Diagnostika;
